import React, { useState } from 'react'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { AlertIcon } from 'src/assets/icons'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import { deleteIssuedCheck } from 'src/app/shared/services/IssuedCheckService'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { NotificationInstance } from 'antd/es/notification/interface'

export interface DeleteIssuedCheckModalProps {
    isOpen: boolean
    onClose: () => void
    checkNumber: string
    id: string
    notiApi: NotificationInstance
    onGridReady?: () => any
}

const DeleteIssuedCheckModal = (props: DeleteIssuedCheckModalProps) => {
    const { isOpen, onClose, checkNumber, id, notiApi, onGridReady } = props
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

    const handleConfirm = async () => {
        try {
            if (id) {
                setLoading(true)
                const response = await deleteIssuedCheck(id)

                if (response?.statusCode === 'Success') {
                    notiApi.success({
                        message: (
                            <RichTextField
                                richText={t('SystemMessages:' + SYSTEM_MESSAGE_IDS.ISSUED_CHECK_DELETED_SUCCESSFULLY, {
                                    checkNumber,
                                })}
                            />
                        ),
                        closeIcon: null,
                    })
                }
            }
        } catch (e) {
        } finally {
            onGridReady?.()
            onClose()
            setLoading(false)
        }
    }

    return (
        <ActionConfirmationModal
            title={t('TransactionResult:modal.title.deleteIssuedCheck')}
            description={<RichTextField richText={t('TransactionResult:modal.description.deleteIssuedCheck', { checkNumber })} />}
            descriptionType='string'
            footer={[
                <Button type='default' onClick={onClose} disabled={loading} key={'cancel'}>
                    {t('common:no')}
                </Button>,
                <Button type='primary' key={'confirm'} onClick={handleConfirm} disabled={loading} loading={loading}>
                    {t('common:yes')}
                </Button>,
            ]}
            isOpen={isOpen}
            onClose={onClose}
            icon={<AlertIcon width={80} height={80} />}
        />
    )
}

export default DeleteIssuedCheckModal
